import React, { Suspense, useState } from 'react';

// import '@ant-design/compatible/assets/index.css';


import moment from 'moment';
import DF from 'DisplayFramework';
import IActions from 'icons/IActions';
import UButton from 'components/Button';
import TextArea from 'antd/lib/input/TextArea';
import {
  Col,
  Row,
  Tabs,
  Card,
  Input,
  Modal,
  Table,
  Select,
  Switch,
  Upload,
  Divider,
  Tooltip,
  Typography,
  DatePicker,
  InputNumber,
  notification,
  Button,
  Spin,
  Form,
  Tag,
} from 'antd';
import {
  DeleteTwoTone,
  UploadOutlined,
  LoadingOutlined,
  PlusSquareTwoTone,
} from '@ant-design/icons';
import FormItem from 'antd/lib/form/FormItem';
import { Document, Page } from 'react-pdf';
import TasksListPopover from '../../workflow/TasksListPopover';

import { UPLOAD_DOC_URL } from 'utils/config';
import ParListSelect from 'components/ParListSelect';

import {
  getScoringFile,
  ScoringFile,
  updateScoringFile,
} from '../../../services/scoring';
import SaveButton from 'components/SaveButton';
import Title from 'components/Title';
import { toCurrency } from 'utils/utils';
import { useQuery } from 'react-query';
import useForm from 'antd/lib/form/hooks/useForm';
import PageLoading from 'pages/Landing/components/PageLoading';
import InputRate from 'components/InputRate';
import InputCurrency from 'components/InputCurrency';
import { useParams } from 'react-router-dom';
import GetLabel from 'DisplayFramework/components/GetLabel';
import UtinaCard from 'components/UtinaCard';
import ThirdPartyModal from 'pages/ThirdParty/ThirdPartyDetail/ThirdPartyModal';
import ModalControllerNV from 'components/ModalControllerNV';
import ProposalModal from 'pages/ProposalV3/ProposalModal';
import FormInput from 'components/FormInput';
import Value from 'components/Value';
import { UploadDocumentFile } from 'utils/request';

const { TabPane } = Tabs;

const { Text } = Typography;
type ScoringDetailV2Props = {
  scoid?: number;
  showAsModal?: boolean;
  fromtp?: boolean;
};

const ScoringDetailV2 = (props: ScoringDetailV2Props) => {
  const { fromtp, scoid, showAsModal } = props;
  let { id } = useParams<{ id: string }>();

  const getId = () => {
    return props.scoid ? (props.scoid === 0 ? undefined : props.scoid) : id;
  };

  const fscoid = getId();

  const [state, setstate2] = useState<any>({
    SCORINGFILE: [],
    SCORINGTABS: [],
    scoid: fscoid,
    isLoading: false,
    fwDisplay: [],
    previewVisibleDOC: false,
    numPages: null,
    pageNumber: 1,
    scale: 1,
    previewTitle: '',
    previewImage: '',
    isPDF: false,
    loadingUpload: false,
    tabPosition: 'left',
  });

  const setState = (val: any) => {
    setstate2({ ...state, ...val });
  };

  const [formRef] = useForm();

  const { data, refetch, isLoading } = useQuery(
    [`getScoringFile`, fscoid],
    () =>
      getScoringFile({ scoid: Number(fscoid) }).then((response) => {
        if (response.code === '403') {
          window.history.replaceState(null, '', '/403');
          window.location.reload();
        }
        if (response.code !== '200') {
          notification.error({
            message: response.message,
            description: response.description,
            duration: 0,
          });
          setState({ isLoading: false });
        } else {
          setState({
            SCORINGFILE: response.data,
            SCORINGTABS: response.data.scoringTabsList,
          });

          formRef.setFieldsValue({
            scoanalystopinion: response.data.scoanalystopinion,
            scorequestedamount: response.data.scorequestedamount,
            scofreecomment: response.data.scofreecomment,
          });
          // renderScoringContent(response.data.scoringTabsList);
        }
        return response.data;
      }),
    {
      enabled: !!fscoid,
    }
  );
  /*
  const componentDidMount = () => {
    setState({ isLoading: true });

    let scoringId = scoid;

    let tabPosition = localStorage.getItem('tabposition');

    if (tabPosition === '' || tabPosition == null) {
      tabPosition = 'left';
    }

    setState({ tabPosition: tabPosition });

    try {
      setState({
        scoid: scoringId,
      });
    } catch (err) {
      setState({
        scoid: scoringId,
      });
    }

    //   loadDisplay('scoringdetail');

    // loadScoringDetail(scoringId);

    setState({ isLoading: false });
  };
*/

  const handleChangeInput = (
    el: any,
    tabid: any,
    lineid: any,
    valuetype: any
  ) => {
    let attTab = state.SCORINGTABS;

    let indTab = attTab.findIndex((tab: any) => tab.tabid === tabid);

    let attLine = state.SCORINGTABS[indTab].scoringAttributeList;

    let indLine = attLine.findIndex((tab: any) => tab.scolineid === lineid);

    attLine[indLine].attvalue = el;

    attTab[indTab].scoringAttributeList = attLine;
    revaluateData(attTab);
  };

  const handleChangeTabInput = (
    e: any,
    column: any,
    tabid: any,
    tableid: any,
    lineid: any
  ) => {
    let attTab = state.SCORINGTABS;

    let indTab = attTab.findIndex((tab: any) => tab.tabid === tabid);

    let attTable = state.SCORINGTABS[indTab].scoringAttributeList;

    let indTable = attTable.findIndex((tab: any) => tab.scolineid === tableid);

    let indLine = attTable[indTable].scoringAttributeLists.findIndex(
      (line: any) => line.scolinelistid === lineid
    );

    switch (column) {
      case 'number1':
        attTable[indTable].scoringAttributeLists[indLine].number1 = e;
        break;

      case 'number2':
        attTable[indTable].scoringAttributeLists[indLine].number2 = e;
        break;

      case 'number3':
        attTable[indTable].scoringAttributeLists[indLine].number3 = e;
        break;

      case 'number4':
        attTable[indTable].scoringAttributeLists[indLine].number4 = e;
        break;

      case 'number5':
        attTable[indTable].scoringAttributeLists[indLine].number5 = e;
        break;

      case 'number6':
        attTable[indTable].scoringAttributeLists[indLine].number6 = e;
        break;

      case 'datestart':
        attTable[indTable].scoringAttributeLists[indLine].datestart =
          moment(e).format('YYYY-MM-DD');
        break;

      case 'dateend':
        attTable[indTable].scoringAttributeLists[indLine].dateend =
          moment(e).format('YYYY-MM-DD');
        break;

      case 'parcode1':
        attTable[indTable].scoringAttributeLists[indLine].parcode1 = e;
        break;
      case 'parcode2':
        attTable[indTable].scoringAttributeLists[indLine].parcode2 = e;
        break;

      case 'parcode3':
        attTable[indTable].scoringAttributeLists[indLine].parcode3 = e;
        break;

      case 'text1':
        attTable[indTable].scoringAttributeLists[indLine].text1 = e;
        break;

      case 'text2':
        attTable[indTable].scoringAttributeLists[indLine].text2 = e;
        break;
      case 'text3':
        attTable[indTable].scoringAttributeLists[indLine].text3 = e;
        break;
      case 'text4':
        attTable[indTable].scoringAttributeLists[indLine].text4 = e;
        break;
      case 'text5':
        attTable[indTable].scoringAttributeLists[indLine].text5 = e;
        break;
      case 'text6':
        attTable[indTable].scoringAttributeLists[indLine].text6 = e;
        break;

      default:
        break;
    }

    attTab[indTab].scoringAttributeList = attTable;

    revaluateData(attTab);
  };

  const revaluateData = (attTab: any) => {
    for (let i = 0; i < attTab.length; i++) {
      for (let j = 0; j < attTab[i].scoringAttributeList.length; j++) {
        if (
          attTab[i].scoringAttributeList[j].parAttribute.attdataorigin ===
            'FORMULA' &&
          (attTab[i].scoringAttributeList[j].parAttribute.attevaluationmode ===
            'CLIENT' ||
            attTab[i].scoringAttributeList[j].parAttribute.attevaluationmode ===
              'BOTH')
        ) {
          let formula =
            attTab[i].scoringAttributeList[j].parAttribute.attformula;
          if (formula !== '') {
            let lfinal = '';
            let cc = '';
            let endAttribut = false;
            let beginAttribut = false;
            let lfunction = '';
            let lattribut = '';

            for (let k = 0; k < formula.length; k++) {
              cc = formula.substr(k, 1);
              if (cc === '[') {
                beginAttribut = true;
                endAttribut = false;
              }
              if (cc === ']') {
                beginAttribut = false;
                endAttribut = true;
              }
              if (beginAttribut) {
                lattribut = lattribut + cc;
              }
              if (endAttribut) {
                let ind = lattribut.indexOf('.');
                if (ind > 0) {
                  let ltable = lattribut.substr(1, ind - 1);
                  let lcolumn = lattribut.substr(ind + 1);
                  let tabind = -1;
                  let attindex = -1;
                  for (let s = 0; s < attTab.length; s++) {
                    attindex = attTab[s].scoringAttributeList.findIndex(
                      (e: any) => e.attcode === ltable
                    );
                    if (attindex >= 0) {
                      tabind = s;
                      break;
                    }
                  }

                  if (attindex >= 0) {
                    let lvalue = calculateAttvalue(
                      lfunction,
                      lcolumn,
                      attTab[tabind].scoringAttributeList[attindex]
                    );
                    lfinal = lfinal.substring(0, lfinal.lastIndexOf(lfunction));

                    lfinal = lfinal + lvalue;
                    lfunction = '';
                  }
                } else {
                  let tabind2 = -1;
                  let attind2 = -1;
                  lattribut = lattribut.substring(1);

                  for (let s = 0; s < attTab.length; s++) {
                    attind2 = attTab[s].scoringAttributeList.findIndex(
                      (e: any) => e.attcode === lattribut
                    );
                    if (attind2 >= 0) {
                      tabind2 = s;

                      break;
                    }
                  }
                  if (attind2 >= 0) {
                    let lvalue2 =
                      attTab[tabind2].scoringAttributeList[attind2].attvalue;

                    lfinal = lfinal + lvalue2;
                    lfunction = '';
                    lattribut = '';
                  }
                }
                endAttribut = false;
              }

              if (beginAttribut === false && endAttribut === false) {
                if (cc !== ']') {
                  lfinal = lfinal + cc;
                  lfunction = lfunction + cc;
                }
              }
            }
            try {
              // eslint-disable-next-line no-eval
              let finalvalue = Function(lfinal);
              attTab[i].scoringAttributeList[j].attvalue = finalvalue;
            } catch (err) {}
          }
        }
      }
    }

    setState({ SCORINGTABS: attTab });
    renderScoringContent(attTab);
  };

  const onChangepdfZoom = (value: any) => {
    setState({ scale: value / 100 });
  };

  const handleCancelPreviewDOC = () => setState({ previewVisibleDOC: false });

  const handlePreviewDOC = (fileurl: any) => {
    let ext = fileurl.substring(fileurl.lastIndexOf('.') + 1);

    if (ext === 'pdf') {
      setState({ isPDF: true });
    } else {
      setState({ isPDF: false });
    }

    setState({
      previewImage: fileurl,
      previewVisibleDOC: true,
      previewTitle: fileurl.substring(fileurl.lastIndexOf('/') + 1),
    });
  };

  const handleUpload = (
    tabid: any,
    scolineid: any,
    attvaluetype: any,
    info: any
  ) => {
    if (info.file.status === 'uploading') {
      setState({ loadingUpload: true });
      return;
    }
    if (info.file.status === 'done') {
      handleChangeInput(
        UPLOAD_DOC_URL + info.file.name,
        tabid,
        scolineid,
        attvaluetype
      );
      setState({ loadingUpload: false });
    }
  };

  const calculateAttvalue = (lfunction: any, column: any, attribut: any) => {
    let value = 0;
    if (lfunction === 'SUM') {
      for (let i = 0; i < attribut.scoringAttributeLists.length; i++) {
        if (column === 'number1') {
          value = value + attribut.scoringAttributeLists[i].number1;
        }
        if (column === 'number2') {
          value = value + attribut.scoringAttributeLists[i].number2;
        }
        if (column === 'number3') {
          value = value + attribut.scoringAttributeLists[i].number3;
        }
        if (column === 'number4') {
          value = value + attribut.scoringAttributeLists[i].number4;
        }
        if (column === 'number5') {
          value = value + attribut.scoringAttributeLists[i].number5;
        }
        if (column === 'number6') {
          value = value + attribut.scoringAttributeLists[i].number6;
        }
      }
    }

    return value;
  };

  const handleDeleteTabInput = (
    e: any,
    column: any,
    tabid: any,
    tableid: any,
    lineid: any
  ) => {
    let attTab = state.SCORINGTABS;
    let indTab = attTab.findIndex((tab: any) => tab.tabid === tabid);
    let attTable = state.SCORINGTABS[indTab].scoringAttributeList;
    let indTable = attTable.findIndex((tab: any) => tab.scolineid === tableid);

    let sAtt = attTable[indTable].scoringAttributeLists.filter(
      (line: any) => line.scolinelistid !== lineid
    );

    attTable[indTable].scoringAttributeLists = sAtt;
    attTab[indTab].scoringAttributeList = attTable;

    revaluateData(attTab);
  };

  const handleAddTabInput = (tabid: any, tableid: any) => {
    let attTab = state.SCORINGTABS;
    let indTab = attTab.findIndex((tab: any) => tab.tabid === tabid);
    let attTable = state.SCORINGTABS[indTab].scoringAttributeList;
    let indTable = attTable.findIndex((tab: any) => tab.scolineid === tableid);

    let lines = attTable[indTable].scoringAttributeLists;

    let count = lines.length;

    let newLine = {
      dateend: moment().format('YYYY-MM-DD'),
      datestart: moment().format('YYYY-MM-DD'),
      number1: null,
      number2: null,
      number3: null,
      number4: null,
      number5: null,
      number6: null,
      parcode1: null,
      parcode2: null,
      parcode3: null,
      scoid: state.scoid,
      scolineid: tableid,
      scolinelistid: count + 1,
      text1: null,
      text2: null,
      text3: null,
      text4: null,
      text5: null,
      text6: null,
    };

    lines = [...lines, newLine];

    attTable[indTable].scoringAttributeLists = lines;

    attTab[indTab].scoringAttributeList = attTable;

    renderScoringContent(attTab);

    setState({ SCORINGTABS: attTab });
  };

  const renderScoringContent = (sTabs: any) => {
    if (sTabs?.length > 0) {
      return sTabs.map((tab: any, index: any) => (
        <TabPane tab={tab.tablabel} key={tab.tabid}>
          <Card>
            <Row gutter={5} className="ColStylesScoring">
              {tab.scoringAttributeList.map((e: any) => {
                return (
                  (e.attvaluetype === 'NUMBER' && (
                    <>
                      <Col span={6}>
                        <Tooltip title={e.parAttribute.attinputhint}>
                          <Text>{e.parAttribute.attlabel}</Text>
                        </Tooltip>
                      </Col>
                      <Col span={4}>
                        {e.parAttribute.attinputformat === 'CURRENCY' ? (
                          <InputCurrency
                            value={e.attvalue}
                            disabled={!e.parAttribute.flagupdate}
                            style={{
                              width: e.parAttribute.attinputwidth,
                              color: e.parAttribute.attinputcolor,
                            }}
                            onChange={(el) => {
                              handleChangeInput(
                                el,
                                tab.tabid,
                                e.scolineid,
                                e.attvaluetype
                              );
                            }}
                            currcode={
                              state.SCORINGFILE.currcode ??
                              localStorage.getItem('currcode') ??
                              ''
                            }
                          />
                        ) : (
                          <InputNumber
                            value={e.attvalue}
                            disabled={!e.parAttribute.flagupdate}
                            style={{
                              width: e.parAttribute.attinputwidth,
                              color: e.parAttribute.attinputcolor,
                            }}
                            onChange={(el) => {
                              handleChangeInput(
                                el,
                                tab.tabid,
                                e.scolineid,
                                e.attvaluetype
                              );
                            }}
                          />
                        )}
                      </Col>
                      <Col span={2}>
                        <Text type="secondary">
                          &nbsp;{e.actiontype === 'EVAL' ? e.attnote : ''}
                        </Text>
                        &nbsp; <Text type="warning">{e.attdecisionlabel}</Text>
                      </Col>
                    </>
                  )) ||
                  (e.attvaluetype === 'TEXT' && !e.parAttribute.flagupdate && (
                    <>
                      <Col span={6}>
                        <Tooltip title={e.parAttribute.attinputhint}>
                          <Text>{e.parAttribute.attlabel}</Text>
                        </Tooltip>
                      </Col>
                      <Col span={4}>
                        <Input
                          value={e.attvalue}
                          // formatter={(value:any) =>
                          //   e.parAttribute.attinputformat === 'CURRENCY'
                          //     ? toCurrency(value,localStorage.getItem('currcode') ?? '')
                          //     : value
                          // }
                          disabled={!e.parAttribute.flagupdate}
                          style={{
                            width: e.parAttribute.attinputwidth,
                            color: e.parAttribute.attinputcolor,
                          }}
                          onChange={(el) => {
                            handleChangeInput(
                              el.target.value,
                              tab.tabid,
                              e.scolineid,
                              e.attvaluetype
                            );
                          }}
                        ></Input>
                      </Col>
                      <Col span={2}>
                        <Text type="secondary">
                          &nbsp;{e.actiontype === 'EVAL' ? e.attnote : ''}
                        </Text>
                        &nbsp; <Text type="warning">{e.attdecisionlabel}</Text>
                      </Col>
                    </>
                  )) ||
                  (e.attvaluetype === 'TEXTAREA' && (
                    <Col span={e.parAttribute?.colspan ?? 12}>
                      {e.parAttribute?.colspan > 12 && <Divider />}
                      <Col span={4}>
                        <Tooltip title={e.parAttribute.attinputhint}>
                          <Text>{e.parAttribute.attlabel}</Text>
                        </Tooltip>
                      </Col>
                      <Col span={e.parAttribute?.colspan}>
                        <TextArea
                          rows={e.parAttribute.attinputrows}
                          value={e.attvalue}
                          // formatter={(value:any) =>
                          //   e.parAttribute.attinputformat === 'CURRENCY'
                          //     ? toCurrency(value,localStorage.getItem('currcode') ?? '')
                          //     : value
                          // }
                          disabled={!e.parAttribute.flagupdate}
                          style={{
                            //width: e.parAttribute.attinputwidth,
                            backgroundColor: e.parAttribute.attinputcolor,
                          }}
                          onChange={(el) => {
                            handleChangeInput(
                              el.target.value,
                              tab.tabid,
                              e.scolineid,
                              e.attvaluetype
                            );
                          }}
                        ></TextArea>
                      </Col>
                      {e.parAttribute?.colspan > 12 && <Divider />}
                    </Col>
                  )) ||
                  (e.attvaluetype === 'TEXT' && e.parAttribute.flagupdate && (
                    <>
                      <Col span={6}>
                        <Tooltip title={e.parAttribute.attinputhint}>
                          <Text>{e.parAttribute.attlabel}</Text>
                        </Tooltip>
                      </Col>
                      <Col span={4}>
                        <Text>
                          {e.parAttribute.attinputformat === 'CURRENCY'
                            ? toCurrency(
                                e.attvalue,
                                state.SCORINGFILE.currcode ??
                                  localStorage.getItem('currcode') ??
                                  ''
                              )
                            : e.attvalue}
                        </Text>
                      </Col>

                      <Col span={2}>
                        <Text type="secondary">
                          &nbsp;{e.actiontype === 'EVAL' ? e.attnote : ''}
                        </Text>
                        &nbsp;<Text type="warning">{e.attdecisionlabel}</Text>
                      </Col>
                    </>
                  )) ||
                  (e.attvaluetype === 'LIST' && (
                    <>
                      <Col span={6}>
                        <Tooltip title={e.parAttribute.attinputhint}>
                          <Text>{e.parAttribute.attlabel}</Text>
                        </Tooltip>
                      </Col>
                      <Col span={4}>
                        <Select
                          value={e.attvalue}
                          disabled={!e.parAttribute.flagupdate}
                          style={{
                            width: e.parAttribute.attinputwidth,
                            color: e.parAttribute.attinputcolor,
                          }}
                          onChange={(el) => {
                            handleChangeInput(
                              el,
                              tab.tabid,
                              e.scolineid,
                              e.attvaluetype
                            );
                          }}
                        >
                          {e.parList != null
                            ? e.parList.map((dat: any) => {
                                return (
                                  <option key={dat.parvalue}>
                                    {dat.parlistlabel}
                                  </option>
                                );
                              })
                            : ''}
                        </Select>
                      </Col>
                      <Col span={2}>
                        <Text type="secondary" style={{ fontWeight: 'bold' }}>
                          &nbsp;{e.actiontype === 'EVAL' ? e.attnote : ''}
                        </Text>{' '}
                        &nbsp; <Text type="warning">{e.attdecisionlabel}</Text>
                      </Col>
                    </>
                  )) ||
                  (e.attvaluetype === 'DATE' && (
                    <>
                      <Col span={6}>
                        <Tooltip title={e.parAttribute.attinputhint}>
                          <Text>{e.parAttribute.attlabel}</Text>
                        </Tooltip>
                      </Col>
                      <Col span={4}>
                        <DatePicker
                          value={
                            moment(e?.attvalue, false).isValid()
                              ? moment(e?.attvalue, false)
                              : undefined
                          }
                          disabled={!e.parAttribute.flagupdate}
                          style={{
                            width: e.parAttribute.attinputwidth,
                            color: e.parAttribute.attinputcolor,
                          }}
                          onChange={(el) => {
                            handleChangeInput(
                              el,
                              tab.tabid,
                              e.scolineid,
                              e.attvaluetype
                            );
                          }}
                        ></DatePicker>
                      </Col>
                      <Col span={3}>
                        <Text type="secondary">
                          &nbsp;{e.actiontype === 'EVAL' ? e.attnote : ''}
                        </Text>{' '}
                        &nbsp;<Text type="warning">{e.attdecisionlabel}</Text>
                      </Col>
                    </>
                  )) ||
                  (e.attvaluetype === 'SWITCH' && (
                    <>
                      <Col span={6}>
                        <Tooltip title={e.parAttribute.attinputhint}>
                          <Text>{e.parAttribute.attlabel}</Text>
                        </Tooltip>
                      </Col>
                      <Col span={4}>
                        <Switch
                          defaultChecked={e.attvalue === 'true' ? true : false}
                          disabled={!e.parAttribute.flagupdate}
                          style={{
                            width: e.parAttribute.attinputwidth,
                            color: e.parAttribute.attinputcolor,
                          }}
                          onChange={(el) => {
                            handleChangeInput(
                              el,
                              tab.tabid,
                              e.scolineid,
                              e.attvaluetype
                            );
                          }}
                        ></Switch>
                      </Col>
                      <Col span={2}>
                        <Text type="secondary">
                          &nbsp;{e.actiontype === 'EVAL' ? e.attnote : ''}
                        </Text>
                        <Text type="warning">{e.attdecisionlabel}</Text>
                      </Col>
                    </>
                  )) ||
                  (e.attvaluetype === 'UPLOAD' && (
                    <>
                      <Col span={6}>
                        <Tooltip title={e.parAttribute.attinputhint}>
                          <Text>{e.parAttribute.attlabel}</Text>
                        </Tooltip>
                      </Col>
                      <Col span={4}>
                        {e.attvalue === '' ? (
                          <Upload
                            name="avatar"
                            multiple={false}
                            // action={UPLOAD_DOC_URL}
                            onPreview={handlePreviewDOC}
                            //beforeUpload={beforeUpload}
                            customRequest={(data: any) => {
                              UploadDocumentFile(
                                data.file,
                                state.SCORINGFILE?.scoreference
                              );
                            }}
                            onChange={(el) => {
                              handleUpload(
                                tab.tabid,
                                e.scolineid,
                                e.attvaluetype,
                                el
                              );
                            }}
                          >
                            <Button>
                              <div>
                                {state.loadingUpload ? (
                                  <LoadingOutlined />
                                ) : (
                                  <UploadOutlined />
                                )}
                                &nbsp;Upload
                              </div>
                            </Button>
                          </Upload>
                        ) : (
                          <div>
                            <Button
                              icon={<DeleteTwoTone />}
                              onClick={(el) => {
                                handleChangeInput(
                                  '',
                                  tab.tabid,
                                  e.scolineid,
                                  e.attvaluetype
                                );
                              }}
                            ></Button>
                            &nbsp;
                            <a
                              onClick={(el) => {
                                el.stopPropagation();
                                handlePreviewDOC(e.attvalue);
                              }}
                              style={{ width: '100%' }}
                            >
                              {e.attvalue.substring(
                                e.attvalue.lastIndexOf('/') + 1
                              )}
                            </a>
                          </div>
                        )}
                      </Col>

                      <Col span={2}>
                        <Text type="secondary">
                          &nbsp;{e.actiontype === 'EVAL' ? e.attnote : ''}
                        </Text>
                        &nbsp; <Text type="warning">{e.attdecisionlabel}</Text>
                      </Col>
                    </>
                  )) ||
                  (e.attvaluetype === 'DIVIDER' && <Divider></Divider>) ||
                  (e.attvaluetype === 'TITLE' && (
                    <>
                      <Col span={24}>
                        <Text
                          strong
                          style={{
                            color: e.parAttribute.attinputcolor,
                            fontSize: e.parAttribute.attinputwidth,
                          }}
                        >
                          {e.parAttribute.attlabel}
                        </Text>
                      </Col>
                      <Divider></Divider>
                    </>
                  )) ||
                  (e.attvaluetype === 'TABLE' && (
                    <Row>
                      <Col span={24}>
                        <Card>
                          <Row>
                            <Col span={22}>
                              {e.flagdisplaytabletitle === true ? (
                                <Tooltip title={e.parAttribute.attinputhint}>
                                  <Text>{e.parAttribute.attlabel}</Text>
                                </Tooltip>
                              ) : null}
                            </Col>
                            <Col span={2}>
                              {e.parAttribute.flagaddline === true ? (
                                <Button
                                  icon={<PlusSquareTwoTone />}
                                  onClick={(evt) => {
                                    evt.stopPropagation();
                                    handleAddTabInput(tab.tabid, e.scolineid);
                                  }}
                                >
                                  Add...
                                </Button>
                              ) : (
                                ''
                              )}
                            </Col>
                          </Row>
                          <Row>
                            <Table
                              columns={e.tablecolumns.map((c: any) => {
                                let data = c.parlist;
                                return {
                                  title: c.label,
                                  dataIndex: c.column,
                                  key: c.column,
                                  width: c.width,
                                  render: (text: any, record: any) =>
                                    e.parAttribute.flagupdate === true ? (
                                      c.type === 'Input' ? (
                                        <Input
                                          defaultValue={
                                            c.column === 'text1'
                                              ? record.text1
                                              : c.column === 'text2'
                                              ? record.text2
                                              : c.column === 'text3'
                                              ? record.text3
                                              : c.column === 'text4'
                                              ? record.text4
                                              : c.column === 'text5'
                                              ? record.text5
                                              : c.column === 'text6'
                                              ? record.text6
                                              : ''
                                          }
                                          onChange={(e) => {
                                            handleChangeTabInput(
                                              e.target.value,
                                              c.column,
                                              tab.tabid,
                                              record.scolineid,
                                              record.scolinelistid
                                            );
                                          }}
                                        ></Input>
                                      ) : c.type === 'InputNumber' ||
                                        c.type === 'InputNumbe' ? (
                                        <InputNumber
                                          defaultValue={
                                            c.column === 'number1'
                                              ? record.number1
                                              : c.column === 'number2'
                                              ? record.number2
                                              : c.column === 'number3'
                                              ? record.number3
                                              : c.column === 'number4'
                                              ? record.number4
                                              : c.column === 'number5'
                                              ? record.number5
                                              : c.column === 'number6'
                                              ? record.number6
                                              : ''
                                          }
                                          onChange={(e) => {
                                            handleChangeTabInput(
                                              e,
                                              c.column,
                                              tab.tabid,
                                              record.scolineid,
                                              record.scolinelistid
                                            );
                                          }}
                                        ></InputNumber>
                                      ) : c.type === 'DatePicker' ? (
                                        <DatePicker
                                          defaultValue={
                                            c.column === 'datestart'
                                              ? moment(
                                                  record.datestart,
                                                  'YYYY-MM-DD'
                                                )
                                              : c.column === 'dateend'
                                              ? moment(
                                                  record.dateend,
                                                  'YYYY-MM-DD'
                                                )
                                              : moment()
                                          }
                                          onChange={(e) => {
                                            handleChangeTabInput(
                                              e,
                                              c.column,
                                              tab.tabid,
                                              record.scolineid,
                                              record.scolinelistid
                                            );
                                          }}
                                        ></DatePicker>
                                      ) : //
                                      c.type === 'action' ? (
                                        <Button
                                          type="link"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleDeleteTabInput(
                                              e,
                                              c.column,
                                              tab.tabid,
                                              record.scolineid,
                                              record.scolinelistid
                                            );
                                          }}
                                        >
                                          Delete
                                        </Button>
                                      ) : c.type === 'Select' ? (
                                        <Select
                                          defaultValue={
                                            c.column === 'parcode1'
                                              ? record.parcode1
                                              : c.column === 'parcode2'
                                              ? record.parcode2
                                              : c.column === 'parcode3'
                                              ? record.parcode3
                                              : ''
                                          }
                                          onChange={(e) => {
                                            handleChangeTabInput(
                                              e,
                                              c.column,
                                              tab.tabid,
                                              record.scolineid,
                                              record.scolinelistid
                                            );
                                          }}
                                        >
                                          {data != null
                                            ? data.map((dat: any) => {
                                                return (
                                                  <option key={dat.parvalue}>
                                                    {dat.parlistlabel}
                                                  </option>
                                                );
                                              })
                                            : ''}
                                        </Select>
                                      ) : (
                                        <Text></Text>
                                      )
                                    ) : (
                                      <Text></Text>
                                    ),
                                };
                              })}
                              dataSource={e.scoringAttributeLists}
                              size="small"
                              scroll={{ y: 400 }}
                              pagination={{ pageSize: 20 }}
                              bordered
                              rowKey={(record) => {
                                return record.scolinelistid;
                              }}
                              summary={(pageData) => {
                                let totalnumber1 = 0;
                                let totalnumber2 = 0;
                                let totalnumber3 = 0;
                                let totalnumber4 = 0;
                                let totalnumber5 = 0;
                                let totalnumber6 = 0;

                                pageData.forEach(
                                  ({
                                    number1,
                                    number2,
                                    number3,
                                    number4,
                                    number5,
                                    number6,
                                  }) => {
                                    totalnumber1 += number1;
                                    totalnumber2 += number2;
                                    totalnumber3 += number3;
                                    totalnumber4 += number4;
                                    totalnumber5 += number5;
                                    totalnumber6 += number6;
                                  }
                                );

                                return (
                                  <Table.Summary.Row>
                                    <Table.Summary.Cell index={0}>
                                      <div
                                        style={{
                                          fontWeight: 'bold',
                                          textAlign: 'right',
                                        }}
                                      >
                                        <Text>Total</Text>
                                      </div>
                                    </Table.Summary.Cell>
                                    {e.tablecolumns.map((c: any) =>
                                      c.type === 'InputNumber' ? (
                                        <Table.Summary.Cell
                                          key={c.column}
                                          index={c.column}
                                        >
                                          {' '}
                                          {/* Ajouter key={index} */}
                                          <Text>
                                            {c.column === 'number1'
                                              ? toCurrency(totalnumber1)
                                              : c.column === 'number2'
                                              ? toCurrency(totalnumber2)
                                              : c.column === 'number3'
                                              ? toCurrency(totalnumber3)
                                              : c.column === 'number4'
                                              ? toCurrency(totalnumber4)
                                              : c.column === 'number5'
                                              ? toCurrency(totalnumber5)
                                              : c.column === 'number6'
                                              ? toCurrency(totalnumber6)
                                              : ''}
                                          </Text>
                                        </Table.Summary.Cell>
                                      ) : null
                                    )}
                                  </Table.Summary.Row>
                                );
                              }}
                            ></Table>
                          </Row>
                        </Card>
                      </Col>
                    </Row>
                  ))
                );
              })}
            </Row>
          </Card>
        </TabPane>
      ));
    }
  };

  const handlerModalShowScoring = (element: any) => {};

  const handleCancelModalShowScoring = (e: any) => {};
  const [loadingBtn, setLoadingBtn] = useState<boolean>(false);
  const validate = (values: any) => {
    formRef
      .validateFields()
      .then((values) => {
        const scoringFile: ScoringFile | any = {
          scoid: state.scoid,
          objectid: state.SCORINGFILE.objectid,
          objecttype: state.SCORINGFILE.objecttype,
          scorequestedamount: values.scorequestedamount,
          scoapprouvedamount: state.SCORINGFILE.scoapprouvedamount,
          scocalculatedamount: state.SCORINGFILE.scocalculatedamount,
          currcode: state.SCORINGFILE.currcode,
          tpid: state.SCORINGFILE.tpid,
          tprole: state.SCORINGFILE.tprole,
          scofreecomment: values.scofreecomment,
          scoanalystopinion: values.scoanalystopinion,
          scoanalystopinionlabel: '',
          scogridid: state.SCORINGFILE.scogridid,
          scoringTabsList: state.SCORINGTABS,
          analystname: '',
          created_at: '',
          created_by: 0,
          objectreference: '',
          scocomment: state.SCORINGFILE.scocomment,
          scodate: '',
          scodecisioncode: '',
          scodecisioncodelabel: '',
          scodecisionlevel: '',
          scodecisionlevellabel: '',
          scodecisiontype: '',
          scolabel: '',
          sconote: 0,
          scoreference: '',
          scoscore: '',
          scostatus: '',
          statuslabel: '',
          tpname: '',
          tpreference: '',
          tprolelabel: '',
          updated_at: '',
          updated_by: 0,
          usernamecreation: '',
        };

        if (state.scoid !== '') {
          setState({ isLoading: true });
          setLoadingBtn(true);
          updateScoringFile({
            scRequest: { ...scoringFile, scoringTabsList: state.SCORINGTABS },
            scoid: state.scoid,
          })
            .then((response) => {
              if (response.code !== '200') {
                notification.error({
                  message: response.code + ' - ' + response.message,
                  description: response.description,
                  duration: 0,
                });
                setLoadingBtn(false);
                setState({ isLoading: false });
              } else {
                setLoadingBtn(false);
                setState({ isLoading: false });
                setState({
                  SCORINGFILE: response.data,
                  SCORINGTABS: response.data.scoringTabsList,
                });

                formRef.setFieldsValue({
                  scorequestedamount: response.data.scorequestedamount,
                  scoanalystopinion: response.data.scoanalystopinion,
                  scofreecomment: response.data.scofreecomment,
                });
                renderScoringContent(response.data.scoringTabsList);
              }
            })
            .catch((err) => {
              setState({ isLoading: false });
              setLoadingBtn(false);
            });
        }
      })
      .catch((err) => {});
  };

  const ScoringContent = renderScoringContent(state.SCORINGTABS);

  const actionsSI = (
    <div>
      <Row>
        <Col span={8} />
        <Col span={8}>
          <TasksListPopover
            entityId={scoid ?? state.scoid}
            entityReference={state.SCORINGFILE?.scoreference}
            entityName="SCORING"
            title={
              state.SCORINGFILE?.scoreference +
              ' - ' +
              state.SCORINGFILE?.tpname
            }
            onClose={refetch}
          >
            <UButton icon={<IActions />} comcode="actions" />
          </TasksListPopover>
        </Col>
        <Col span={8}>
          <SaveButton
            // style={{ marginleft: '15px' }}
            onClick={validate}
            loading={state.isLoading || loadingBtn}
            comcode="save"
            hidden={state.SCORINGFILE.scostatus === 'VALID'}
            custom={{ height: 52 }}
          />
        </Col>
      </Row>
    </div>
  );
  const colorTag = (scostatus: string) => {
    if (scostatus === 'VALID') {
      return 'success';
    } else if (scostatus === 'INIT') {
      return 'default';
    }
    return '';
  };
  const tabScoring = (
    <Tabs
      tabPosition="left"
      tabBarExtraContent={state.tabPosition === 'top' ? actionsSI : null}
      defaultActiveKey="0"
    >
      <TabPane tab="Scoring" key="0">
        <Card
          size="small"
          type="inner"
          // className={'card'}
          title={<GetLabel label="Scoring" />}
          bordered
        >
          <Row gutter={10}>
            <FormInput
              col
              md={6}
              name="ScoringFileref"
              wrapperCol={{ md: 8 }}
              labelAlign="left"
            >
              <Text>{state.SCORINGFILE.scoreference}</Text>
            </FormInput>

            {state.SCORINGFILE.referenceyear && (
              <FormInput
                col
                md={6}
                name="referenceyear"
                wrapperCol={{ md: 8 }}
                labelAlign="left"
              >
                <Text>{state.SCORINGFILE.referenceyear}</Text>
              </FormInput>
            )}

            <FormInput
              col
              md={6}
              name="ScoringFiledate"
              wrapperCol={{ md: 8 }}
              labelAlign="left"
            >
              <Text>
                {moment(state.SCORINGFILE.scodate).format('YYYY-MM-DD')}
              </Text>
            </FormInput>

            <FormInput
              col
              md={6}
              name="Status"
              wrapperCol={{ md: 8 }}
              labelAlign="left"
            >
              <Tag color={colorTag(state.SCORINGFILE.scostatus)}>
                {state.SCORINGFILE.statuslabel}
              </Tag>
            </FormInput>
          </Row>
          <Row style={{ marginTop: '20px' }}>
            <Col span={14}>
              <UtinaCard
                comcode="generalinfo"
                level={5}
                styleCard={{ height: '92%' }}
              >
                <Row gutter={16}>
                  <Col span={4}>
                    {' '}
                    <GetLabel label="grid" />
                  </Col>
                  <Col span={8}>
                    <Text>{state.SCORINGFILE.scolabel}</Text>
                  </Col>
                </Row>

                {state.SCORINGFILE.objecttype === 'PROPOSAL' ? (
                  <Row gutter={16} style={{ marginTop: '20px' }}>
                    <Col span={4}>
                      <GetLabel label="object" />
                    </Col>
                    <Col span={8}>
                      <ModalControllerNV
                        modal={({ setVisible, visible }) => (
                          <ProposalModal
                            ctrid={state.SCORINGFILE.objectid}
                            visible={visible}
                            onCancel={() => setVisible(false)}
                            onSuccess={() => setVisible(false)}
                            title=""
                            phase={state.SCORINGFILE.objecttypes}
                            iscreate={false}
                          />
                        )}
                        content={({ setVisible, visible }) => (
                          <a onClick={() => setVisible(true)}>
                            {state.SCORINGFILE.objectreference}
                          </a>
                        )}
                      />
                    </Col>
                    <Col span={4}>
                      {' '}
                      <GetLabel label="thirdparty" />
                    </Col>
                    <Col span={8}>
                      <ModalControllerNV
                        content={({ setVisible, visible }) => (
                          <a
                            onClick={() => {
                              setVisible(true);
                            }}
                          >
                            {state.SCORINGFILE.tpreference} -{' '}
                            {state.SCORINGFILE.tpname}
                          </a>
                        )}
                        modal={({ setVisible, visible }) => (
                          <ThirdPartyModal
                            tpId={state.SCORINGFILE.tpid}
                            visible={visible}
                            onCancel={() => setVisible(false)}
                            onSuccess={() => setVisible(false)}
                            title={state.tpname}
                            iscreate={false}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                ) : (
                  <Row gutter={16} style={{ marginTop: '20px' }}>
                    <Col span={4}>
                      <GetLabel label="thirdparty" />
                    </Col>
                    <Col span={8}>
                      <ModalControllerNV
                        content={({ setVisible, visible }) => (
                          <a
                            onClick={() => {
                              setVisible(true);
                            }}
                          >
                            {state.SCORINGFILE.tpreference} -{' '}
                            {state.SCORINGFILE.tpname}
                          </a>
                        )}
                        modal={({ setVisible, visible }) => (
                          <ThirdPartyModal
                            tpId={state.tpid}
                            visible={visible}
                            onCancel={() => setVisible(false)}
                            onSuccess={() => setVisible(false)}
                            title={state.tpname}
                            iscreate={false}
                          />
                        )}
                      />
                    </Col>
                  </Row>
                )}
                <Row style={{ marginTop: '20px' }} gutter={20}>
                  <Col span={12}>
                    {/* <GetLabel label="scorequestedamount" /> */}

                    <FormInput
                      name="scorequestedamount"
                      style={{ width: '65%' }}
                    >
                      <InputCurrency
                        type="danger"
                        currcode={state.SCORINGFILE.currcode}
                      />
                    </FormInput>
                  </Col>
                  <Col span={6}>
                    <GetLabel label="scoapprouvedamount" />
                  </Col>
                  <Col span={6}>
                    <Text type="danger">
                      {toCurrency(
                        state.SCORINGFILE.scoapprouvedamount,
                        state.SCORINGFILE.currcode
                      )}
                    </Text>
                  </Col>
                </Row>
              </UtinaCard>
            </Col>
            <Col span={10}>
              <UtinaCard comcode="amount" level={5}>
                <Row gutter={8}>
                  <Col span={12}>
                    <GetLabel label="Decision" />
                  </Col>
                  <Col span={12}>
                    <Text
                      strong
                      style={
                        state.SCORINGFILE.scodecisioncode === 'AVISP'
                          ? { color: 'green' }
                          : state.SCORINGFILE.scodecisioncode === 'AVISN'
                          ? { color: 'red' }
                          : state.SCORINGFILE.scodecisioncode === 'DISCUSS'
                          ? { color: 'orange' }
                          : { color: 'blue' }
                      }
                    >
                      {state.SCORINGFILE.scodecisioncodelabel}
                    </Text>
                  </Col>

                  <Col span={12}>
                    <GetLabel label="decisionlevel" />
                  </Col>
                  <Col span={12}>
                    <Text>{state.SCORINGFILE.scodecisionlevellabel}</Text>
                  </Col>

                  <Col span={12}>
                    <GetLabel label="scodecisiontype" />
                  </Col>
                  <Col span={12}>
                    <Text>{state.SCORINGFILE.scodecisiontype}</Text>
                  </Col>
                  <Col span={12}>
                    <GetLabel label="scoscore" />
                  </Col>
                  <Col span={12}>
                    <Text
                      strong
                      style={
                        state.SCORINGFILE.scodecisioncode === 'AVISP'
                          ? { color: 'green' }
                          : state.SCORINGFILE.scodecisioncode === 'AVISN'
                          ? { color: 'red' }
                          : state.SCORINGFILE.scodecisioncode === 'DISCUSS'
                          ? { color: 'orange' }
                          : { color: 'blue' }
                      }
                    >
                      {state.SCORINGFILE.scoscore}
                    </Text>
                  </Col>
                  {/* <Col span={12}>
                    <GetLabel label="Sconote" />
                  </Col> */}

                  <Col span={12}>
                    <FormInput name="sconote" comcode="Sconote">
                      <Value value=""></Value>
                    </FormInput>
                  </Col>
                  <Col span={12}>
                    <Text
                      strong
                      style={{
                        color:
                          state.SCORINGFILE.scodecisioncode === 'AVISP'
                            ? 'green'
                            : state.SCORINGFILE.scodecisioncode === 'AVISN'
                            ? 'red'
                            : state.SCORINGFILE.scodecisioncode === 'DISCUSS'
                            ? 'orange'
                            : 'blue',
                      }}
                    >
                      {state.SCORINGFILE.sconote}
                    </Text>
                  </Col>

                  {/* <Col span={24}>
                  <FormInput name="sconote" comcode="Sconote">
                    <Text
                      strong
                      style={
                        state.SCORINGFILE.scodecisioncode === 'AVISP'
                          ? { color: 'green' }
                          : state.SCORINGFILE.scodecisioncode === 'AVISN'
                          ? { color: 'red' }
                          : state.SCORINGFILE.scodecisioncode === 'DISCUSS'
                          ? { color: 'orange' }
                          : { color: 'blue' }
                      }
                    >
                      {state.SCORINGFILE.sconote}
                    </Text>
                    </FormInput>
                  </Col> */}

                  {/* <Col span={4}>
                    <GetLabel label="Analyst" />
                  </Col> */}

                  <Col span={12}>
                    <FormInput name="analystname" comcode="Analyst">
                      <Value value={state.SCORINGFILE.analystname} />
                    </FormInput>
                  </Col>

                  {/* <Col span={4}>
                    <GetLabel label="Opinion" />
                  </Col> */}
                  <Col span={12}>
                    <FormInput name="scoanalystopinion" comcode="Opinion">
                      {state.SCORINGFILE.scostatus === 'INIT' ? (
                        <ParListSelect parcode="OPINION" />
                      ) : (
                        <Value
                          value={state.SCORINGFILE.scoanalystopinionlabel}
                        />
                      )}
                    </FormInput>
                  </Col>
                </Row>
              </UtinaCard>
            </Col>
          </Row>
          <Divider />
          <Row>
            <UtinaCard
              comcode="comment"
              level={5}
              styleCard={{ height: '92%' }}
              lg={23}
            >
              <Col span={24}>
                <Text strong>
                  {String(state.SCORINGFILE?.scocomment ?? '')
                    ?.replace(/\n+/g, '\n')
                    ?.replace('null', '')
                    ?.split('\n')
                    ?.map((line, index) => (
                      <span key={index}>
                        {line} <br />
                      </span>
                    ))}
                </Text>
              </Col>
            </UtinaCard>
          </Row>
          <Divider />
          <Row>
            <Col span={24}>
              <GetLabel label="freecomment" />
            </Col>
            <Col span={24}>
              <FormItem name="scofreecomment">
                <TextArea rows={5}>{state.SCORINGFILE.scofreecomment}</TextArea>
              </FormItem>
            </Col>
          </Row>
        </Card>
      </TabPane>

      {ScoringContent}
    </Tabs>
  );

  const previewVisibleDOC = state.previewVisibleDOC;
  const { pageNumber, numPages, scale, previewTitle, previewImage } = state;

  return (
    (<DF.Provider pagcode="scoringdetail">
      <Row style={{ fontSize: '14px', fontWeight: 'bold' }}>
        <Col span={16}>
          {Number(data?.scoid) > 1 ? (
            <div style={{ fontSize: 16 }}>
              {'SC : ' +
                data?.scoreference +
                ' - Prop : ' +
                data?.objectreference +
                ' - TP : ' +
                data?.tpname}
            </div>
          ) : (
            <Title level={4} comcode="PleaseWait"></Title>
          )}
        </Col>
        <Col span={8} style={{ textAlign: 'right' }}>
          {state.tabPosition === 'left' ? actionsSI : null}
        </Col>
      </Row>
      <div>
        <Spin spinning={isLoading}>
          <Form
            layout="horizontal"
            form={formRef}
            // loading={state.isLoading}
            // onFinish={ExecuteEvent}
            // onFinishFailed={onFinishFailed}
          >
            <Suspense fallback={<PageLoading />}>{tabScoring}</Suspense>
          </Form>
        </Spin>
      </div>
      <Modal
        open={previewVisibleDOC}
        title={previewTitle}
        footer={null}
        onCancel={handleCancelPreviewDOC}
        width="700px"
        style={{
          top: 20,
          right: 0,
        }}
      >
        {state.isPDF && (
          <div>
            <Row>
              <Col>
                {/* <InputNumber
                    min={10}
                    max={200}
                    formatter={(value) => `${value}%`}
                    parser={(value) => value.replace('%', '')}
                    step={10}
                    defaultValue={100}
                    onChange={onChangepdfZoom}
                  /> */}
                <InputRate
                  min={10}
                  max={200}
                  step={10}
                  defaultValue={100}
                  onChange={onChangepdfZoom}
                />
              </Col>
            </Row>
            <Document
              file={previewImage}
              // onLoadSuccess={onDocumentLoadSuccess}
            >
              <Page pageNumber={pageNumber} scale={scale} />
            </Document>
            <p>
              Page {pageNumber} of {numPages}
            </p>
          </div>
        )}

        {!state.isPDF && (
          <img alt="example" style={{ width: '100%' }} src={previewImage} />
        )}
      </Modal>
    </DF.Provider>)
  );
};

export default ScoringDetailV2;
